import React from 'react';
import moment from 'moment';
import red from '@material-ui/core/colors/red';
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ValidatorComponent } from 'react-form-validator-core';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

const red300 = red['500'];

const style = {
    right: 0,
    fontSize: '12px',
    color: red300,
};

export default class TimePickerValidator extends ValidatorComponent {
    renderValidatorComponent() {
        const {
            error,
            errorMessages,
            validators,
            requiredError,
            validatorListener,
            withRequiredValidator,
            containerProps,
            ...rest
        } = this.props;
        const { isValid } = this.state;

        return (
            <div>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <TimePicker
                        {...rest}
                        error={!isValid || error}
                    />
                    {this.errorText()}
                </LocalizationProvider>
            </div>
        );
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <div style={style}>
                {this.getErrorMessage()}
            </div>
        );
    }
}